import styled from 'styled-components';
import { cssVarColors } from '../../../Constants';
import { Card, CardContent, Link } from '@mui/material';

export const UserListingWrapper = styled.div`
	background-color: ${cssVarColors.dark};
	display: flex;
	min-height: 100%;
	width: 100%;
	flex: 1;
	font-size: 1.4em;
`;

export const UsersListingCard = styled(Card)`
	background-color: #000 !important;
	display: flex;
	flex-direction: column;
	min-width: 100%;
	flex: 1;
`;

export const UsersListingCardContent = styled(CardContent)`
	color: #fff;
	padding: 1em;
`;

export const UserListingHeaderRowWrapper = styled('div')`
	flex: 1;
	flex-direction: row;
	display: flex;
	align-items: center;
	justify-content: center;
	padding: 1em;
	background-color: ${cssVarColors.onSurfaceSecondary};
`;

export const UserListingHeaderCell = styled('div')`
	flex: 1;
`;

export const UserListingRowWrapper = styled('div')`
	padding: 1em;
	flex: 1;
	flex-direction: row;
	display: flex;
	align-items: center;
	justify-content: center;
	&:nth-child(odd) {
		background-color: ${cssVarColors.odd};
	}
	&:hover {
		background-color: ${cssVarColors.highlight};
	}
`;

export const UserListingCellWrapper = styled('div')`
	flex: 1;
`;

export const EnhancedLink = styled(Link)`
	color: ${cssVarColors.secondaryBackground} !important;
`;

export const UserListingInfoWrapper = styled('div')`
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	align-items: center;
`;

export const UserListingSwitchWrapper = styled('div')`
	display: flex;
	flex-direction: row;
	align-items: center;
`;
